// 三级系列切换逻辑
document.addEventListener('DOMContentLoaded', function () {
    // 选中所有拥有选项卡的列表块
    const listItems = document.querySelectorAll('.list-item');

    listItems.forEach((item) => {
    const tabs = item.querySelectorAll('.tab-btn');
    const panels = item.querySelectorAll('.tab-panel');

    if (tabs.length === 0) return; // 如果没有三级分类则跳过

    tabs.forEach((tab) => {
        tab.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-target');

        // 1. 移除当前区块所有 tab 的 active 状态
        tabs.forEach((t) => t.classList.remove('active'));
        // 给被点击的 tab 添加 active
        this.classList.add('active');

        // 2. 切换当前区块下方对应产品的显示/隐藏
        panels.forEach((panel) => {
            if (panel.id === targetId) {
            panel.style.display = 'block';
            // 解决被隐藏的面板显示时缺失动画或者排版错乱的问题
            if (panel.classList.contains('scroll-trigger')) {
                panel.classList.add('scroll-trigger--cancel');
            }
            } else {
            panel.style.display = 'none';
            }
        });
        });
    });
    });
});